import { MoneyConnectClientAPI } from "./axios-service-creator";

export const SecondMarketAPI = {
  getProductOfferingList: (payload) =>
    MoneyConnectClientAPI.post("/digitalbond/product/getProductOfferingList", payload),
  getProductOfferingDetail: (payload) =>
    MoneyConnectClientAPI.post("/digitalbond/product/getProductOfferingDetail", payload),
  sendOTP: (payload) => MoneyConnectClientAPI.post("/digitalbond/otp/send", payload),
  confirmPayment: (payload) => MoneyConnectClientAPI.post("/digitalbond/payment/confirm", payload),
  confirmPaymentLombard: (payload) =>
    MoneyConnectClientAPI.post("/digitalbond/lombardLoan/transaction/confirm", payload),
  confirmSellLombard: (payload) => MoneyConnectClientAPI.post("/digitalbond/lombardLoan/confirm/redemption", payload),
  getSellInventory: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/getSellInventory", payload),
  getBuyInventory: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/getBuyInventory", payload),
  getConfirmationInfo: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/confirmation", payload),
  getCustomerOutstanding: (payload) =>
    MoneyConnectClientAPI.post("/digitalbond/outstanding/getCustomerOutstanding", payload),
  getSecuritiesDetail: (payload) => MoneyConnectClientAPI.post("/digitalbond/outstanding/getSecuritiesDetail", payload),
  getBondInfoUrl: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/getBondInfoUrl", payload),
  requestApprove: (payload) => MoneyConnectClientAPI.post("/digitalbond/lombardLoan/requestApprove", payload),
  continuePurchaseLombardSecondaryMarket: (id, signal) =>
    MoneyConnectClientAPI.get("/digitalbond/lombardLoan/confirmation", { params: { id }, signal }),
  cancelLombard: (payload) => MoneyConnectClientAPI.post("/digitalbond/lombardLoan/transaction/cancel", payload),
  getPreTestDetail: (payload) => MoneyConnectClientAPI.post("/digitalbond/pre-subscription-test/detail", payload),
  acceptPreSubscription: (payload) => MoneyConnectClientAPI.post("/digitalbond/pre-subscription-test/accept", payload),
  enableAcceptationForPreSubscription: (payload) =>
    MoneyConnectClientAPI.post("/digitalbond/pre-subscription-test/pre-accept", payload),
  getRecommenders: (payload) => MoneyConnectClientAPI.post("/digitalbond/product/verify-recommender", payload),
};
